import React from "react";

import { Row } from "react-bootstrap";

// data
import { UserTypesAndGender } from "../../../utility/content/UserTypesAndGender";

import { StyledRadioInput, StyledRadioContent } from "./userTypeAndGenderSelectionStyled";

const UserRoleSelection = ({ handleSubmit }) => {
  return (
    <Row>
      {UserTypesAndGender.map(({ id, image, alt, title, gender, type }) => {
        return (
          <label
            key={id}
            htmlFor={alt}
            className="col-6 gy-2 justify-content-center"
            onClick={(e) => handleSubmit(e, gender, type)}
          >
            <StyledRadioInput type="radio" name={alt} />
            <StyledRadioContent className="radio-content">
              <img src={image} alt={alt} className="img-fluid" />
              <figcaption>{title}</figcaption>
            </StyledRadioContent>
          </label>        
        );
      })}
    </Row>
  );
};

export default UserRoleSelection;
